<template>
	<div class="main bgwhite" v-title data-title="零部件企业">
		<iHeader ref="loginIndex" :message="msg" @func="getbanner"></iHeader>
		<el-carousel :interval="5000" arrow="always" class="icomswiper clearfix">
			<el-carousel-item v-for="(item,index) in cbanner" :key="index">
				<!-- <img :src="item.url" alt="" style="max-width: 100%; height: 300px;"> -->
				<div :style="{background:'url('+item.url+')',
				    backgroundSize:'cover',
					backgroundRepeat:'no-repeat',
					backgroundPosition:'center center',
				    width:'100%',
					height:'400px'
				}"></div>
			</el-carousel-item>
		</el-carousel>
		<div class="barprebox max1350 mt25">
			<div class="tjgoods">
				<div class="brandT pdl8">
					<div class="proL">产品推荐</div>
					<div class="proR curhand">查看更多</div>
				</div>
				<div class="pdb30">
					<div class="demo-image curhand txl" v-if="product_list.length>0">
						<div class="block blockInfo wpro" v-for="(item,index) in product_list"
							@mousemove="addClassload($event)" @mouseout="removeClassload($event)"
							@click="jumpurl(item.id)" :title="item.title" :key="index">
							<el-image style="width: 190px; height: 190px" :src="'https://images.mfcad.cn/'+item.thumb"
								fit="cover" @mousemove="ImgaddClassload($event)" @mouseout="ImgremoveClassload($event)">
							</el-image>
							<div class="font14 fl mt10 bold overtitleOne" style="width: 100%;">{{item.title}}</div>
						</div>
					</div>
					<div class="demo-image curhand txc" v-else-if="product_list.length==0">
						<i class="iconfont icon-icon-no-data"></i>
						<p style="padding-top: 10px;">暂无数据</p>
					</div>
				</div>
			</div>
		</div>
		<v-footer></v-footer>
	</div>
</template>

<script>
	import Cookies from 'js-cookie'
	// 公共头部组件
	import iHeader from "@/components/indexheader"
	// footer
	import vFooter from "@/components/Footer"
	import "@/assets/cont-01.css";
	import Vue from 'vue';
	import axios from 'axios';
	Vue.prototype.$axios = axios;
	export default {
		components: {
			iHeader,
			vFooter,
		},
		data() {
			return {
				msg: "company",
				product_list: [],
				cuserid: '',
				cbanner: [{
						url: 'https://static.mfcad.com/lingbujian/pc-img/banner1.jpg'
					}
				]
			}
		},
		created() {
		
			Cookies.set('cuserid', this.$route.query.cid);
			// this.handentinfo()
			this.handProlist()
		},
		methods: {
			getbanner(data) {
				// this.cbanner = data
			},
			handProlist() {
				this.$postcn('partshome/tuijainpro', {
					userid: Cookies.get('cuserid')
				}, this).then((res) => {
					if (res.data.length > 0) {
						this.product_list = res.data
					}
				})
			},
			ImgaddClassload($event) {
				$event.currentTarget.className = "el-image__inner Wactive";
			},
			ImgremoveClassload($event) {
				$event.currentTarget.className = "el-image__inner";
			},
			addClassload($event) {
				$event.currentTarget.className = "block blockInfo active";
			},
			removeClassload($event) {
				$event.currentTarget.className = "block blockInfo";
			},
		}
	}
</script>

<style scoped="scoped">
	/* 当只有一张图是左右轮播箭头隐藏 */
	.Wactive {
		width: 190PX;
		cursor: pointer;
		transform: scale(1.5, 1.5)
	}

	.active {
		border-color: #1f75cf !important;
		color: #1f75cf;
	}

	.nodiv {
		padding-top: 100px;
	}


	.font22 {
		font-size: 22px;
	}

	.pd25Left {
		padding: 0px 25px 30px 25px;
		text-align: left;
	}

	.demo-image .blockInfo {
		margin-top: 10px;
	}

	.icon-icon-no-data {
		font-size: 66px;
		margin-top: 50px;
		display: inline-block;
		margin-bottom: 30px;
	}
    .clearfix:after { content: "."; display: block; height: 0; clear: both; visibility: hidden; font-size: 0; }
    .clearfix { zoom: 1; }
	.blockInfo {
		padding: 10px 10px 20px 10px;
		text-align: center;
		display: inline-block;
		width: 252px;
		/* margin: 10px; */
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		vertical-align: top;
		background-color: #fafafa;
		border: 1px solid #eaeaea;
	}

	.el-image {
		position: relative;
		display: inline-block;
		overflow: hidden;
	}

	.tjgoods .brandT {
		height: 56px;
		border-bottom: 1px solid #F2F2F2;
		margin: 0 auto;
	}

	.tjgoods .proL {
		float: left;
		border-left: 3px solid #005dbe;
		padding-left: 10px;
		margin: 15px 0;
		padding-left: 10px;
		font-size: 20px;
		font-weight: bold;
	}

	.tjgoods .proR {
		float: right;
		color: #005dbe;
		margin: 10px 0;
		margin: 20px 20px;
		font-size: 13px;
	}

	.demo-image .blockInfo:nth-child(1),
	.demo-image .blockInfo:nth-child(2),
	.demo-image .blockInfo:nth-child(3),
	.demo-image .blockInfo:nth-child(4),
	.demo-image .blockInfo:nth-child(6),
	.demo-image .blockInfo:nth-child(7),
	.demo-image .blockInfo:nth-child(8),
	.demo-image .blockInfo:nth-child(9) {
		margin-right: 10px;
	}
</style>
<style>
	.icomswiper .el-carousel__container {
		height: 400px;
	}

	/* .icomswiper .el-carousel__arrow--left,
	.icomswiper .el-carousel__arrow--right {
		display: none;
	} */
</style>



// WEBPACK FOOTER //
// src/pages/company/icompany.vue